import { render, staticRenderFns } from "./F24BusinessRules.vue?vue&type=template&id=b1091c92&scoped=true"
import script from "./F24BusinessRules.vue?vue&type=script&lang=js"
export * from "./F24BusinessRules.vue?vue&type=script&lang=js"
import style0 from "./F24BusinessRules.vue?vue&type=style&index=0&id=b1091c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1091c92",
  null
  
)

export default component.exports